<svelte:options runes={false} />

<script>
  import { minorToMoney } from '../../api/invoices';
  import { riskKindLabel, statusLabel } from '../status-labels.mjs';

  export let risk;
</script>

<article class:blocking-risk={risk.blocking} class="risk-card">
  <div>
    <h3>{riskKindLabel(risk.kind)}</h3>
    <p>{minorToMoney(risk.amountMinor, risk.currency)} · {statusLabel(risk.status)}</p>
  </div>
  <div class="risk-detail">
    <strong>{risk.blocking ? 'Blocks future settlement' : 'Resolved observation'}</strong>
    <span>{risk.latestProviderCreatedAt?.toLocaleString?.() || ''}</span>
    <code>{risk.providerReference}</code>
  </div>
</article>
